import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/user-organisations")({
    beforeLoad: () => {
        throw redirect({ to: "/users/organisations", replace: true });
    },
});
